export default __webpack_public_path__ + "static/media/pajak.d9af5840.png";